import { Footer } from "../components/Footer/Footer";
import { Navbar } from "../components/Navbar/Navbar";
import { Box, Typography } from "@mui/material";

const HomePage = () => {

    return (
        <>
            <Navbar />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: 4,
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        width: { md: '900px' },
                        height: 'auto',
                        mb: 4,
                        overflow: 'hidden', // Per limitare l'area visibile
                    }}
                >
                    <img
                        src="/images/homepage-senza-mic.webp"
                        alt="About Me"
                        style={{ width: '100%', height: 'auto', display: 'block' }}
                    />
                    {/* Overlay con sfumatura */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            /*
                            background: `linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.5)),
                            linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.5))`,
                            backgroundBlendMode: 'overlay',
                            */
                            //background: 'radial-gradient(circle, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 1))',
                            pointerEvents: 'none', // L'overlay non interferisce con i clic
                        }}
                    />
                </Box>
                {/* Inizio Sezione video */}
                <Typography variant="subtitle1"
                    sx={{
                        mb: 1,
                        mt: { xs: 4, md: 8 },
                        px: { md: 6 },
                        textAlign: 'center'
                    }}
                >
                    Non dirmi che hai paura &ndash; Music by Francesco Alemanno
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%', // Imposta la larghezza al 100%
                        maxWidth: '900px', // Massima larghezza a 900px
                        height: '0', // Impostiamo l'altezza a 0
                        overflow: 'hidden',
                        marginBottom: 4,
                        marginTop: 4,
                        aspectRatio: '16 / 9',
                    }}
                >
                    <iframe
                        src="https://www.youtube.com/embed/2a6J6jAf4NU?si=zRoBkR1Mnoxezuw3"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </Box>
                {/* Fine Sezione video */}
                {/* Inizio Sezione video */}
                <Typography variant="subtitle1"
                    sx={{
                        mb: 1,
                        mt: { xs: 4, md: 8 },
                        px: { md: 6 },
                        textAlign: 'center'
                    }}
                >
                    Conad Natale 2024 &ndash; Music by Francesco Alemanno
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%', // Imposta la larghezza al 100%
                        maxWidth: '900px', // Massima larghezza a 900px
                        height: '0', // Impostiamo l'altezza a 0
                        overflow: 'hidden',
                        marginBottom: 4,
                        marginTop: 4,
                        aspectRatio: '16 / 9',
                    }}
                >
                    <iframe
                        src="https://www.youtube.com/embed/B_p5gXwHmnA?si=zZzUqr4wucdwpu3D"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </Box>
                {/* Fine Sezione video */}
                {/* Inizio Sezione video */}
                <Typography variant="subtitle1"
                    sx={{
                        mb: 1,
                        mt: { xs: 4, md: 8 },
                        px: { md: 6 },
                        textAlign: 'center'
                    }}
                >
                    Jeep Avenger &ndash; Music by Francesco Alemanno
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%', // Imposta la larghezza al 100%
                        maxWidth: '900px', // Massima larghezza a 900px
                        height: '0', // Impostiamo l'altezza a 0
                        overflow: 'hidden',
                        marginBottom: 4,
                        marginTop: 4,
                        aspectRatio: '16 / 9',
                    }}
                >
                    <iframe
                        src="https://www.youtube.com/embed/5-aIOwk3EmU?si=gnAxMM_KD2s44Za6"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </Box>
                {/* Fine Sezione video */}
                {/* Inizio Sezione video */}
                <Typography variant="subtitle1"
                    sx={{
                        mb: 1,
                        mt: { xs: 4, md: 8 },
                        px: { md: 6 },
                        textAlign: 'center'
                    }}
                >
                    Arrival &ndash; Music by Francesco Alemanno
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%', // Imposta la larghezza al 100%
                        maxWidth: '900px', // Massima larghezza a 900px
                        height: '0', // Impostiamo l'altezza a 0
                        overflow: 'hidden',
                        marginBottom: 4,
                        marginTop: 4,
                        aspectRatio: '16 / 9',
                    }}
                >
                    <iframe
                        src="https://www.youtube.com/embed/IV2oIyVJoNc?si=dGuDzNa7_ew9gY5u"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </Box>
                {/* Fine Sezione video */}
                {/* Inizio Sezione video */}
                <Typography variant="subtitle1"
                    sx={{
                        mb: 1,
                        mt: { xs: 4, md: 8 },
                        px: { md: 6 },
                        textAlign: 'center'
                    }}
                >
                    Nike Air VaporMax &ndash; Music by Francesco Alemanno
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%', // Imposta la larghezza al 100%
                        maxWidth: '900px', // Massima larghezza a 900px
                        height: '0', // Impostiamo l'altezza a 0
                        overflow: 'hidden',
                        marginBottom: 4,
                        marginTop: 4,
                        aspectRatio: '16 / 9',
                    }}
                >
                    <iframe
                        src="https://www.youtube.com/embed/cWzC6Jz5vns?si=k8MHg2XhUVjvf-aq"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </Box>
                {/* Fine Sezione video */}
                {/* Inizio Sezione video */}
                <Typography variant="subtitle1"
                    sx={{
                        mb: 1,
                        mt: { xs: 4, md: 8 },
                        px: { md: 6 },
                        textAlign: 'center'
                    }}
                >
                    Arborea &ndash; Music by Francesco Alemanno
                </Typography>
                <Box
                    sx={{
                        position: 'relative',
                        width: '100%', // Imposta la larghezza al 100%
                        maxWidth: '900px', // Massima larghezza a 900px
                        height: '0', // Impostiamo l'altezza a 0
                        overflow: 'hidden',
                        marginBottom: 4,
                        marginTop: 4,
                        aspectRatio: '16 / 9',
                    }}
                >
                    <iframe
                        src="https://www.youtube.com/embed/RV5Pec7UUQw?si=jZGqJcpLbIKSPrsY"
                        title="YouTube video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                        }}
                    />
                </Box>
                {/* Fine Sezione video */}

                {/*<Typography variant="subtitle2">
                    Here you can find all the information about me and my work. Feel free to explore.
                </Typography>
                */}
            </Box>
            <Footer />

        </>
    )
}
export default HomePage;